<template>
  <div class="d-none d-sm-block">
    <b-breadcrumb v-if="raw_breadcrumb" ref="breadcrumb">
      <b-breadcrumb-item
        v-for="(item, index) in raw_breadcrumb"
        :to="getUrl(item)"
        :key="index"
        :active="index+1==raw_breadcrumb.length"
      >
        <font-awesome-icon v-if="index == 0" icon="home" />
        <span class="breadcrumb-text" v-else>
          <p>{{ translate(item.langkey) }}</p>
        </span>
      </b-breadcrumb-item>
    </b-breadcrumb>
  </div>
</template>


<script>
import { mapState } from "vuex";

export default {
  name: "the-breadcrumb",
  computed: {
    ...mapState({
      raw_breadcrumb: state => state.siteconf.raw_breadcrumb,
    }),
  },
  methods: {
    getUrl(item) {
      //Devuelve la url del breadcrumb

      var url = { name: item.route };
      // Si tiene parametros configurados en el router/index.js los incluye
      if (item.params && item.params.length) {
        var params = {};
        for (var i = 0; i < item.params.length; i++) {
          params[item.params[i]] = this.getParamFromUrl(item.params[i]);
        }
        url["params"] = params;
      }
      // Creamos la url con los parametros que nos envian desde el loadBreacrumbs
      if (item.params) {
        url["params"] = item.params;
      }
      if (item.query) {
        url["query"] = item.query;
      }
      return url;
    },
    translate(item) {
      if (item && item.namespace && item.text) {
        return this.$tradukojTranslate(item);
      }
      return this.$t(item);
    },
    getParamFromUrl(item) {
      if (item) {
        return this.$route.params[item];
      } else {
        return null;
      }
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        home: { breadcrumb: "Home" },
        user_home: { breadcrumb: "My account" },
        register: { breadcrumb: "Register" },
        login: { breadcrumb: "Login" },
        recover_pass: { breadcrumb: "Forget your password?" },
        recover_pass_confirm: { breadcrumb: "Reset your password" },
        results: { breadcrumb: "Results" },
        pharmacies: { breadcrumb: "Pharmacies" },
        user_information: { breadcrumb: "Personal data" },
        user_historial: { breadcrumb: "Orders History" },
        user_address: { breadcrumb: "My addresses" },
        user_address_new: { breadcrumb: "New address" },
        user_program: { breadcrumb: "Programs" },
        brands: { breadcrumb: "Brand Drugs" },
        order_detail: { breadcrumb: "Order detail" },
        cart_review: { breadcrumb: "Order review" },
        cart_confirm: { breadcrumb: "Order confirm" },
        categories: { breadcrumb: "Categories" },
        doctor_information: { breadcrumb: "Doctor data" },
        doctor_list: { breadcrumb: "Doctor information" },
      },
    },
  },
};
</script>


<style scoped lang="scss">
.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  list-style: none;
  background-color: $grey2-color;
  border-radius: 0.25rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
  a {
    color: $text-main-color;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}

.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  color: $text-main-color;
  content: "»";
}

.breadcrumb-item a {
  color: $text-main-color;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}

.breadcrumb-item.active {
  color: $text-main-color;
}

.breadcrumb-text {
  p {
    text-transform: lowercase;
    margin-bottom: 0;
    display: inline-block;
  }
  p::first-letter {
    text-transform: uppercase;
  }
}
</style>
